import { render } from "./WarrantyList.vue?vue&type=template&id=3b2644c4&scoped=true"
import script from "./WarrantyList.vue?vue&type=script&lang=js"
export * from "./WarrantyList.vue?vue&type=script&lang=js"

import "./WarrantyList.vue?vue&type=style&index=0&id=3b2644c4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2644c4"]])

export default __exports__